import { apiClient, ICollectionResponse } from '@/resources/upgrade/jsonapi-client';
import { ILibrarianResource } from '@/resources/upgrade/LibrarianResource';

export function librarianResourcesQueryOptions() {
  return {
    queryKey: ['librarian-resources'],
    queryFn: async () => {
      // Collection endpoint - kitsu keeps { data, meta } wrapper
      const response = await apiClient.get<ICollectionResponse<ILibrarianResource>>('librarian_resources');

      return response.data;
    },
    staleTime: 1000 * 60 * 5,
  };
}
